<script>
  export let color = "var(--pax-white)";
  export let size = 24;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  height="{size}px"
  viewBox="0 -960 960 960"
  width="{size}px"
  ><path
    d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"
    fill={color}
  /></svg
>
